<template>
  <button class="btn-log-out img-r" :class="{ transparent }" @click="$auth.logout()">
    <span>{{ $t('btn-log-out') }}</span>
    <img src="@/assets/icons/log-out.svg" alt="" />
  </button>
</template>

<script>
export default {
  name: 'btn-log-out',
  props: {
    transparent: {
      default: true,
    },
  },
}
</script>

<style lang="scss">
.btn-log-out {
  color: $gray;
}
</style>
